import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

/**
 * Contractors API Service
 * Mock API calls for Contractors management
 * Using dummy endpoints that follow the system pattern
 */

export const GetAllContractorsApi = async (projectId) => {
  try {
    // No projectId = business-wide (contractors aren't project-scoped). Old:
    // const response = await axiosInstance.get(`/Contractors/GetAll?ProjectId=${projectId}`);
    const query = projectId ? `?ProjectId=${projectId}` : "";
    const response = await axiosInstance.get(`/Contractors/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddContractorApi = async (data) => {
  try {
    const response = await axiosInstanceForm.post(`/Contractors/Add`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateContractorApi = async (data, id) => {
  try {
    const response = await axiosInstanceForm.put(`/Contractors/Update?contractorId=${id}`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeleteContractorApi = async (contractorId, projectId) => {
  try {
    const response = await axiosInstance.delete(
      `/Contractors/Delete?contractorId=${contractorId}&projectId=${projectId}`,
    );
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
